<template>
  <v-app>
    <div>
      <v-snackbar style="z-index: 2 !important;" transition="slide-x-reverse-transition" v-model="snackbar" timeout="800"
        :value="true" :color="snakclr" absolute outlined top right>
        <v-icon :color="snakclr">mdi-alert-outline</v-icon>
        {{ errMsg }}
        <v-icon @click="snackbar = false" class="float-right" :color="snakclr">mdi-close-circle</v-icon>

      </v-snackbar>
    </div>
    <v-container class="pa-0 pa-sm-3 pa-md-3">
      <div class="px-sm-4">
        <v-toolbar dense class="elevation-0 mb-4 mt-6">
          <v-toolbar-title>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold headline">User profile</v-list-item-title>
                <v-list-item-subtitle class="body-1 mb-0 mt-1" color="#878B93">
                  your personal details here.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="pt-2 px-4">
          <v-row class="d-flex flex-column-reverse flex-md-row">
            <v-col cols="12" md="7">
              <p class="mb-2">Personal</p>
              <v-card outlined>
                <v-progress-linear color="#3B82F6" v-if="userloader" indeterminate></v-progress-linear>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Name</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title>{{ UserDetails.BRANCH_HEAD ? UserDetails.BRANCH_HEAD : UserDetails.Name ?
                      UserDetails.Name : '-' }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Email ID</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title>{{ UserDetails.EMAIL_ID ? UserDetails.EMAIL_ID : UserDetails.Email ?
                      UserDetails.Email : '-' }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Mobile number</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title>{{ UserDetails.TEL_NO ? UserDetails.TEL_NO : UserDetails.Mobile ?
                      UserDetails.Mobile : '-' }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
              <p class="mb-2 mt-6">Address</p>
              <v-card class="elevation-0 rounded-md pa-2" outlined>
                <v-progress-linear color="#3B82F6" v-if="userloader" indeterminate></v-progress-linear>
                <span class="text-lowercase" v-if="UserDetails.ADDRESS">{{
                  UserDetails.ADDRESS }}, {{ UserDetails.CITY }}, {{ UserDetails.STATE }}</span><span
                  v-else>-</span></v-card>
              <!-- <p class="mb-2 mt-6">Bank</p>
              <v-card outlined>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Bank name</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title>{{ UserDetails.REM_BANK_NAME }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Account.No</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title>{{ UserDetails.RemBankAcBNo }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>IFSC CODE</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title>{{ UserDetails.REM_IFSC_CODE }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card> -->
              <p v-if="modeis != 'r'" class="mb-2 mt-6">Employee</p>
              <v-card v-if="modeis != 'r'" class="trdditl elevation-0 mt-2">
                <v-data-table :loading="employeeloader" disable-sort style="border: 1px solid #efeef3;"
                  class="elevation-0" dense :headers="headers" fixed-header :items="employeedata" :items-per-page="5"
                  :sort-by="['doj']" :sort-desc="[true]">
                  <!-- <template v-slot:top>
                    <v-toolbar flat dense class="px-4">
                      <v-toolbar-title class="subtitle-1">Employee
                      </v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                      <v-btn text @click="openEmp" color="#3B82F6" class="elevation-0 text-capitalize font-weight-bold">
                        + Add
                      </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                  </template> -->
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn @click="editEmp(item)" icon small class="text-align-center mr-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 28 28" fill="none">
                        <path
                          d="M5 18.7782C5.00006 18.481 5.11819 18.1959 5.32841 17.9858L17.8214 5.49281C17.9775 5.33658 18.1629 5.21264 18.3669 5.12808C18.571 5.04352 18.7897 5 19.0106 5C19.2315 5 19.4502 5.04352 19.6542 5.12808C19.8583 5.21264 20.0437 5.33658 20.1998 5.49281L23.0972 8.3902C23.2534 8.54634 23.3774 8.73173 23.4619 8.93578C23.5465 9.13983 23.59 9.35854 23.59 9.57942C23.59 9.8003 23.5465 10.019 23.4619 10.2231C23.3774 10.4271 23.2534 10.6125 23.0972 10.7686L10.6042 23.2616C10.3941 23.4718 10.109 23.5899 9.81179 23.59H6.12085C5.82358 23.59 5.53849 23.4719 5.32829 23.2617C5.11809 23.0515 5 22.7664 5 22.4692V18.7782ZM6.12085 18.7782V22.4692H9.81179L22.3047 9.9762C22.3569 9.92414 22.3983 9.8623 22.4266 9.79421C22.4548 9.72613 22.4694 9.65313 22.4694 9.57942C22.4694 9.5057 22.4548 9.43271 22.4266 9.36463C22.3983 9.29654 22.3569 9.2347 22.3047 9.18264L19.4074 6.28525C19.3553 6.23306 19.2935 6.19165 19.2254 6.1634C19.1573 6.13515 19.0843 6.12061 19.0106 6.12061C18.9369 6.12061 18.8639 6.13515 18.7958 6.1634C18.7277 6.19165 18.6659 6.23306 18.6138 6.28525L6.12085 18.7782Z"
                          fill="currentColor" />
                        <path
                          d="M16.3721 7.73451L20.8555 12.2179L21.649 11.4243L17.1657 6.94095L16.3721 7.73451ZM6.28448 17.8221L10.7679 22.3055L11.5614 21.512L7.07804 17.0286L6.28448 17.8221Z"
                          fill="currentColor" />
                        <path d="M18.6138 9.18265L8.52618 19.2703L9.31974 20.0638L19.4074 9.97621L18.6138 9.18265Z"
                          fill="currentColor" />
                      </svg>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols="12" md="5" class="text-center mb-6 mt-8 mt-md-16">

              <v-avatar size="160" color="#3B82F6">
                <span style="font-size:88px;" class="white--text font-weight-bold text-uppercase">{{
                  UserDetails.BRANCH_CODE ? UserDetails.BRANCH_CODE.slice(0, 1) : UserDetails.Code ?
                  UserDetails.Code.slice(0, 1) : null
                }}</span>
              </v-avatar>
              <!-- <p class="font-weight-bold mb-0 mt-2">{{ UserDetails.REMESHIRE_NAME }}</p> -->
              <p class="subtitle-1 mb-0">{{ UserDetails.BRANCH_CODE ? UserDetails.BRANCH_CODE : UserDetails.Code ?
                UserDetails.Code : null }}</p>
              <!-- <p class="mb-1">since : {{ UserDetails.Agreement_date.slice(0, 10) }}</p> -->
              <!-- <p @click="copylink()" class="body-2">
                <span style="background-color:#EFF6FF;" class="py-1 px-2 rounded-lg">
                  https://oa.mynt.in/?ref={{
                    UserDetails.BRANCH_CODE }}<v-icon size="14">mdi-content-copy</v-icon>
                </span>
              </p> -->
            </v-col>
          </v-row>
        </div>
      </div>
    </v-container>
    <v-dialog v-model="empdialog" hide-overlay class="elevation-0" max-width="600px">
      <v-card class="trdditl" width="100%">
        <v-toolbar flat dense class="px-4">
          <v-toolbar-title class="subtitle-1">Add Employee details
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text icon @click="empdialog = false">
            <v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="pa-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field color="#3B82F6" v-model="brcode" disabled outlined dense label="Branch code"></v-text-field>
            <v-text-field color="#3B82F6" v-model="empcode" outlined dense
              :rules="[v => !!v || 'Employee code is required']" required label="Employee code"></v-text-field>
            <v-text-field color="#3B82F6" v-model="empname" outlined dense
              :rules="[v => !!v || 'Employee name is required']" required label="Employee name"></v-text-field>
            <v-text-field color="#3B82F6" v-model="empdesig" outlined dense
              :rules="[v => !!v || 'Employee designation is required']" required
              label="Employee designation"></v-text-field>
            <v-menu ref="menu" :close-on-content-click="false" :return-value.sync="doj" transition="scale-transition"
              offset-y max-width="290px" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field color="#3B82F6" class="rounded-lg mt-2" outlined dense hide-details v-model="doj"
                  label="Date of joining" prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker :max="latest" @change="datePickerclose" v-model="doj" type="date" no-title scrollable>
              </v-date-picker>
            </v-menu>
            <v-text-field color="#3B82F6" v-model="ctc" class="mt-6" outlined dense
              :rules="[v => !!v || 'Monthly CTC is required']" required label="Monthly CTC"></v-text-field>
            <v-select color="#3B82F6" outlined class=" rounded-lg" dense :items="['Active', 'Inactive']" label="Status"
              v-model="status" hide-details></v-select>

            <v-row>
              <v-col>
                <v-btn @click="empdialog = false" color="#ECEFF1" class="rounded-md elevation-0" block large>
                  <span class="font-weight-bold black--text text-capitalize">
                    cancel
                  </span>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn block large type="submit" :disabled="!valid" color="#1e53e5" class="rounded-md elevation-0"
                  @click="validate">
                  <span class="font-weight-bold white--text text-capitalize">
                    Validate
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>
  
<script>
import axios from "axios";
import { apiurl } from "../apiUrl";
// import FormData from "form-data";
// import fs from fs-extra
export default {
  data() {
    return {
      employeeloader: true,
      userloader: true,
      valid: true,

      empdialog: false,
      errMsg: '',
      imageUrll: '',
      previewImagee: '',
      addimageprofile: true,
      preview: null,
      image: null,
      snackbar: false,
      snakclr: 'default',
      signinemailname: "",
      imageUrl: '',
      date: null,
      name: "",
      email: "",
      dobmenu: "",
      mobile: "",
      userdataview: true,
      getUserDetails: [],
      UserDetails: [],
      switch1: false,
      bankInfo: false,
      employeedata: [],
      brcode: null,
      empcode: null,
      empname: null,
      empdesig: null,
      ctc: null,
      status: null,

      doj: new Date().toISOString().substr(0, 10),
      past: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 7),

      latest: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      modeis: null,

    };
  },

  created() {
    let modeis = localStorage.getItem('mode');
    this.brcode = localStorage.getItem('brcode');
    if (modeis == 'RM') {
      this.modeis = 'r';
      this.clientstype = 'RM';
    } else {
      this.modeis = 'b';
      this.clientstype = 'All';
    }

    this.getEmployeedata();
  },
  mounted() {
    this.profileValidation();
  },
  methods: {
    profileValidation() {
      this.userloader = true;
      let data = JSON.stringify({
        "BRANCH_CODE": this.brcode
      });

      let config = {
        method: 'post',
        url: `${apiurl}/user_profile`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      let axiosThis = this
      axios.request(config)
        .then((response) => {
          if (response.data.msg != "this branch code doesn't exists") {
            axiosThis.UserDetails = response.data[0];
          }
          axiosThis.userloader = false;
        })
        .catch((error) => {
          console.log(error);
        });

    },
    copylink() {
      navigator.clipboard.writeText(`https://oa.mynt.in/?ref=${this.UserDetails.BRANCH_CODE}`);
      this.errMsg = 'Link as copied ';
      this.snackbar = true;
      this.snakclr = 'success'
    },
    datePickerclose() {
      this.$refs.menu.save(this.doj)
    },
    openEmp() {
      this.empdialog = true;
      this.$refs.form.reset();
    },
    editEmp(item) {
      this.empcode = item.Employee_code
      this.empname = item.Employee_name
      this.empdesig = item.Employee_designation
      this.doj = item.Date_of_joining
      this.ctc = item.Monthly_CTC
      this.status = item.Status
      this.empdialog = true;
    },
    getEmployeedata() {
      this.employeedata = [];
      this.employeeloader = true;
      let data = JSON.stringify({
        "type": "view",
        "Branch_code": this.brcode,
      });

      let config = {
        method: 'post',
        // url: 'http://192.168.5.163:5005/employee_data',
        url: `${apiurl}/employee_data`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      let axiosThis = this;
      axios.request(config)
        .then((response) => {
          if (response.data.length > 0) {
            axiosThis.employeedata = response.data;
          }
          axiosThis.employeeloader = false;

        })
        .catch((error) => {
          console.log(error);
        });

    },
    validate() {
      if (this.$refs.form.validate() == true) {
        let data = JSON.stringify({
          "type": "add",
          "Branch_code": this.brcode,
          "Employee_code": this.empcode,
          "Employee_name": this.empname,
          "Employee_designation": this.empdesig,
          "Date_of_joining": this.doj,
          "Monthly_CTC": this.ctc,
          "Status": this.status
        });

        let config = {
          method: 'post',
          // url: 'http://192.168.5.163:5005/employee_data',
          url: `${apiurl}/employee_data`,
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        };
        let axiosThis = this;
        axios.request(config)
          .then((response) => {
            axiosThis.snackbar = true;
            axiosThis.empdialog = false;
            if (response.data.msg == "data inserted") {
              axiosThis.snakclr = 'success';
              axiosThis.errMsg = 'Data inserted';
              axiosThis.getEmployeedata()
            } else {
              axiosThis.snakclr = 'error';
              axiosThis.errMsg = response.data.msg;
            }
          })
          .catch((error) => {
            console.log(error);
          });

        // 
      }
    },
  },
  computed: {
    headers() {
      return [
        { text: "Br_code", value: "Branch_code" },
        { text: "Emp_code", value: "Employee_code" },
        { text: "Emp_name", value: "Employee_name" },
        { text: "Emp_desig", value: "Employee_designation" },
        // { text: "DOJ", value: "Date_of_joining" },
       // { text: "CTC", value: "Monthly_CTC", align: 'right' },
        // { text: "Status", value: "Status" },
        // { text: "", value: "action" },


        // { text: "Branch code", value: "brcode"},
        // { text: "Employee code", value: "empcode"},
        // { text: "Employee name", value: "name"},
        // { text: "Employee designation", value: "designation"},
        // { text: "DOJ", value: "doj"},
        // { text: "Monthly CTC", value: "ctc", align: 'right' },
        // { text: "Status", value: "Status"},
      ];
    },
  },
};
</script>
<style lang="scss">
.file-input {
  display: none
}

.profile-container {
  width: 150px;
  height: 150px;
  overflow: hidden;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  border-radius: 50%;
}</style>